class CartDrawer extends HTMLElement {
   constructor() {
      super();
      this.$drawer = null;
      this.$overlay = null;
      this.$closeBtn = null;
      this.$itemsContainer = null;
      this.$subtotalEl = null;
   }

   connectedCallback() {
      this.init();
   }

   init() {
      this.$drawer = $(this);
      if (!this.$drawer.length) return;

      this.mergeAddonProducts = true; // Set to false to show separately 
      this.defaultGroupsOpen = true; // Set to false to start accordion groups closed

      this.$wrapper = this.$drawer.find('[data-cart-drawer-content]');
      this.$itemsContainer = this.$drawer.find('[data-cart-drawer-items]');
      this.$cartCount = $('[data-cart-count]');

      this.bindEvents(); 
   }

   bindEvents() {
      const self = this;

      // Events bound to the cart-drawer element (not document)
      // Click events delegate within the drawer
      this.$drawer.on('click', '[data-cart-drawer-close]', function () {
         self.close();
      });

      this.$drawer.on('click', '[data-cart-drawer-overlay]', function () {
         self.close();
      });

      this.$drawer.on('click', '[data-qty-change]', function (e) {
         const $btn = $(e.currentTarget);
         const change = parseInt($btn.attr('data-qty-change'));
         const line = parseInt($btn.attr('data-line'));

         const $input = $btn.parent().find('[data-qty-input]');
         const currentQty = parseInt($input.val());
         const newQty = Math.max(1, currentQty + change);
         self.updateQuantity(line, newQty);
      });

      this.$drawer.on('click', '[data-cart-remove]', function (e) {
         const line = parseInt($(e.currentTarget).attr('data-line'));
         self.removeItem(line);
      });

      this.$drawer.on('click', '.price-includes-addons', function (e) {
         const $parent = $(this).closest('.cart-item');
         const $group = $parent.next();
         const isActive = $parent.hasClass('active');

         $group.css('maxHeight', isActive ? '' : `${$group[0].scrollHeight}px`);
         // fix - set new height for when content breaks to new lines
         if (!isActive) {
            setTimeout(() => {
               $group.css('maxHeight', `${$group[0].scrollHeight}px`);
            }, 360);
         }
         $parent.toggleClass('active');

         const strings = window.theme?.strings;
         $(this).text(isActive ? strings?.show_details || 'Show Details' : strings?.hide_details || 'Hide Details');
      });

      // Header cart icon - delegate to document
      $(document).on('click', '.header-bar__cart a', function (e) {
         e.preventDefault();
         self.open();
      });
   }

   open() {
      this.$drawer.addClass('is-open');
      // $('body').css('overflow', 'hidden');

      this.handleAddonProductDisplay();
   }

   close() {
      this.$drawer.removeClass('is-open');
      $('body').css('overflow', '');
   }

   // Get sections to render for cart updates
   getSectionsToRender() {
      return [
         {
            id: 'cart-drawer',
            section: 'cart-drawer',
            selector: '[data-cart-drawer-content]',
         },
         {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.header-bar__cart',
         },
      ];
   }

   // Full cart/drawer update
   // Required by avis
   async refresh() {
      // console.log('refresh');
      // try {
      // const sectionsToRender = this.getSectionsToRender().map(section => section.section);
      //    const html = await cartApi.getSections('cart-drawer');
      //    this.renderContents(html);
      // } catch (err) {
      //    console.error('Error refreshing cart:', err);
      //    throw err;
      // }
   }

   // Required by Avis
   renderContents(parsedState) {
      // console.log('renderContents', parsedState);

      if (!parsedState || !parsedState.sections || !Object.keys(parsedState.sections).length) {
         console.error('No sections passed to renderContents. Getting sections...');
         // Todo call cartApi to get sections

         const self = this;
         const sectionsToRender = this.getSectionsToRender().map(section => section.section);

         cartApi
            .getSections(sectionsToRender)
            .then(function (sectionsData) {
               // Combine with original data
               const completeData = Object.assign({}, parsedState, { sections: sectionsData });
               self.renderContents(completeData);
            })
            .catch(function (error) {
               console.error('Error fetching sections:', error);
            });
         return;
      }

      const self = this;

      // Update each section
      this.getSectionsToRender().forEach(function (section) {
         const $sectionElement = section.selector ? $(section.selector) : self.$wrapper;

         if ($sectionElement.length && parsedState.sections[section.section]) {
            const sectionHTML = parsedState.sections[section.section];
            const selector = section.selector;
            const $newContent = $(sectionHTML).find(selector);
            $sectionElement.html($newContent.html());
         }
      });

      // Re-initialize references (events stay bound to cart-drawer element)
      this.$wrapper = this.$drawer.find('[data-cart-drawer-content]');
      this.$itemsContainer = this.$drawer.find('[data-cart-drawer-items]');

      // Handle addon products
      this.handleAddonProductDisplay();

      const itemCount = this.$itemsContainer.find('.cart-item:not(.apo-addon-item)').length;

      // Close drawer if empty
      if (itemCount === 0) {
         this.close();
      } else if (!this.suppressOpen) {
         this.open();
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
   }

   // Required by Avis
   // renderContents(openDrawer = false) {
   //    const self = this;
   //    this.refresh().then(function () {
   //       if (openDrawer) {
   //          self.open();
   //       }
   //    });
   // }

   // Required by Avis
   refreshCartDrawer(cart) {
      // console.log('refreshCartDrawer');
      if (!cart) return;
      const self = this;
      cartApi.getSections(['cart-drawer', 'cart-icon-bubble']).then(function (sections) {
         self.renderContents({ sections: sections });
      });
   }

   // Merge addon products
   // ------------------------------------------------------------------------------
   handleAddonProductDisplay() {
      if (!this.mergeAddonProducts || this.$itemsContainer.hasClass('grouped')) return;

      const $cartItems = this.$itemsContainer.find('.cart-item');
      const mainProducts = new Map(); // Store main products and their addons

      const self = this;
      const $mainProducts = this.$itemsContainer.find('.apo-main-item');
      const $addonProducts = this.$itemsContainer.find('.apo-addon-item');
      $mainProducts.each(function () {
         const apoOrderId = $(this).data('apo-order-id');
         // $relatedAddons.wrapAll('<div class="cart-item__group"><div class="cart-item__group-inner" /></div>');

         const $innerGroup = $('<div class="cart-item__group-inner" />');
         const $properties = $(this).find('.cart-item__properties').detach(); // move properties
         const $relatedAddons = $addonProducts.filter('[data-apo-order-id="' + apoOrderId + '"]');

         $innerGroup.append($properties);
         $innerGroup.append($relatedAddons);

         const $group = $('<div class="cart-item__group" />');
         $group.append($innerGroup);
         $(this).after($group);

         if (self.defaultGroupsOpen) {
            $(this).addClass('active');
            $group.css('transition', 'none');
            $group.css('maxHeight', `${$group[0].scrollHeight}px`);
            // Re-enable transition after paint so subsequent toggles animate normally
            requestAnimationFrame(() => $group.css('transition', ''));
            const strings = window.theme?.strings;
            $(this).find('.price-includes-addons').text(strings?.hide_details || 'Hide Details');
         }
      });

      $cartItems.each(function () {
         const $item = $(this);
         const isAddon = $item.hasClass('apo-addon-item');
         const apoOrderId = $item.data('apo-order-id');

         if (!apoOrderId) return; // Skip if no product ID

         if (isAddon) {
            // Hide addon products
            // $item.hide();

            // Ensure main product entry exists (in case addon comes before main)
            if (!mainProducts.has(apoOrderId)) {
               mainProducts.set(apoOrderId, {
                  $element: null,
                  addons: [],
               });
            }

            // Add addon to main product's addon list
            mainProducts.get(apoOrderId).addons.push($item);
         } else {
            // Track main products
            if (!mainProducts.has(apoOrderId)) {
               mainProducts.set(apoOrderId, {
                  $element: $item,
                  addons: [],
               });
            } else {
               // Main product found after addon - update the element reference
               mainProducts.get(apoOrderId).$element = $item;
            }
         }
      });

      // console.log('mainProducts', mainProducts);

      // Update main product displays with consolidated info
      mainProducts.forEach(function (productData, productId) {
         if (productData.$element) {
            self.consolidateMainProduct(productData.$element, productData.addons);
         }
      });
      this.$itemsContainer.addClass('grouped');
   }

   consolidateMainProduct($mainElement, addonElements) {
      if (!$mainElement || addonElements.length === 0) return;

      // Calculate total price (main + addons)
      const mainPrice = this.extractPrice($mainElement);
      let totalAddonPrice = 0;

      const self = this;
      $.each(addonElements, function (index, $addon) {
         totalAddonPrice += self.extractPrice($addon);

         // Add addon properties to main product
         const $addonProperties = $addon.find('.cart-item__properties');
         if ($addonProperties.length) {
            let $propertiesContainer = $mainElement.find('.cart-item__properties');
            if (!$propertiesContainer.length) {
               $propertiesContainer = self.createPropertiesContainer($mainElement);
            }
            $propertiesContainer.append($addonProperties.html());
         }
      });

      // Update main product price to include addons
      const newTotalPrice = mainPrice + totalAddonPrice;
      this.updateMainProductPrice($mainElement, newTotalPrice);
   }

   extractPrice($itemElement) {
      const $priceElement = $itemElement.find('.cart-item__total');
      if (!$priceElement.length || !$priceElement.data('price')) return 0;

      // Get raw price from data attribute (in cents)
      return parseInt($priceElement.data('price')) || 0;
   }

   updateMainProductPrice($mainElement, newPriceCents) {
      const $priceElement = $mainElement.find('.cart-item__total');
      if (!$priceElement.length) return;

      // Format the new price
      const formattedPrice = window.Shopify?.formatMoney ? Shopify.formatMoney(newPriceCents, window.theme.moneyFormat) : '$' + (newPriceCents / 100).toFixed(2);

      $priceElement.text(formattedPrice);

      // Add CSS class for styling
      // if (!$mainElement.find('.price-includes-addons').length) {
      //    $mainElement.find('.cart-item__quantity').append('<div class="price-includes-addons">(view sub-products)</div>');
      // }
   }

   createPropertiesContainer($mainElement) {
      const $details = $mainElement.find('.cart-item__details');
      const $container = $('<div class="cart-item__properties product-option-property"></div>');
      $details.append($container);
      return $container;
   }
   // ------------------------------------------------------------------------------

   updateQuantity(line, quantity) {
      this.changeCartItem({ line: line, quantity: quantity });
   }

   removeItem(line) {
      // if (!confirm('Remove this item from cart?')) return;
      this.changeCartItem({ line: line, quantity: 0 });
   }

   // Consolidated method for cart changes
   changeCartItem(changeData) {
      const data = $.extend({}, changeData, {
         sections: this.getSectionsToRender()
            .map(section => section.section)
            .join(','),
      });

      const self = this;
      cartApi
         .change(data)
         .then(function (response) {
            // renderContents handles response with sections
            self.renderContents(response);
         })
         .catch(function (error) {
            console.error('Error changing cart item: %o', error);

            // Show error message for the specific line item
            if (changeData.line && error.status === 422) {
               const availableQty = error.data?.quantity || changeData.quantity - 1;
               self.showQuantityError(changeData.line, availableQty);
            }
         });
   }

   showQuantityError(line, availableQty) {
      const $cartItem = this.$itemsContainer.find('[data-line="' + line + '"]');
      if (!$cartItem.length) return;

      const $errorEl = $cartItem.find('[data-cart-item-error]');
      if (!$errorEl.length) return;

      // Get translated message template
      const errorMessage = window.theme?.strings?.limited_availability;

      $errorEl.text(errorMessage);
      $errorEl.addClass('show');

      // Hide after x seconds
      setTimeout(function () {
         $errorEl.removeClass('show');
      }, 2500);
   }
}

customElements.define('cart-drawer', CartDrawer);
